/*
 * @Description: 
 * @Author: xiong.zhou@dmall.com
 * @Date: 2022-03-18 10:29:17
 * @LastEditors: xiong.zhou@dmall.com
 * @LastEditTime: 2023-02-26 22:14:55
 */
export function openWindow(href, target = '_blank') {
    const aTag = document.createElement('a');
    aTag.href = href;
    aTag.target = target;
    aTag.click();
}
export function virtualDownLoad(href, name) {
    const downloadElement = document.createElement('a');
    downloadElement.href = href;
    if(name) {
        [downloadElement.download] = [name];
    }
    document.body.appendChild(downloadElement);
    downloadElement.click();
    document.body.removeChild(downloadElement);
}

//截取url地址上的参数
export function getUrlData(strName){   
    var urlStr = location.href;
    var index = urlStr.indexOf('?');
    var paramStr = urlStr.substr(index+1);
    var paramArr = paramStr.split('&');
    for(var i = 0; i < paramArr.length; i++) {
        var param = paramArr[i].split("=");
        if(param[0].toUpperCase() == strName.toUpperCase()){
            return param[1];
        }
    }
}
// 转换时间字符串
export function getTimeStr(time){   
    const timeDiff = new Date().getTime() - new Date(time);
    const hoursDiff = timeDiff / 1000 / 60 / 60;

    if (hoursDiff < 1) {
        return '刚刚';
    } else if (hoursDiff < 24) {
        return `${Math.floor(hoursDiff)}小时前`;
    } else {
        return time.split(' ')[0];
    }
}
